import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Pagination } from "../../shared/pagination.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { BasicApiResponseModel, PagingResponseModel } from "../../shared/api-response.model";
import { Core2Config } from "../../shared/core2Config";

import { ApiVisa } from "../../shared/api-visa.model";
import { Observable } from "rxjs";
import { StockReplenishmentRunHdrModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-run-hdr.model";

@Injectable({ providedIn: "root" })
export class StockReplenishmentRunHdrService extends BaseApiTemplateService<StockReplenishmentRunHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    "erp/stock-replenishment-run-hdrs/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/stock-replenishment-run-hdrs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/stock-replenishment-run-hdrs/backoffice-ep";
    this.httpClient = theHttp;
  }

  /** Manually Run Processor */
  public runProcessor(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/manual-run/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
